import React, { useEffect, useState } from 'react';
import BottomTabNavigation from './BottomTabNavigation';

const OpenPlayToolsLayout = ({ children, userRole = 'player' }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  useEffect(() => {
    try {
      const saved = window.localStorage.getItem('openplay_sidebar_collapsed');
      if (saved === '1') setSidebarCollapsed(true);
    } catch {
      // ignore
    }
  }, []);

  useEffect(() => {
    const handler = (e) => {
      const next = !!e?.detail?.collapsed;
      setSidebarCollapsed(next);
    };

    try {
      window.addEventListener('openplay_sidebar_collapsed_change', handler);
    } catch {
      // ignore
    }

    return () => {
      try {
        window.removeEventListener('openplay_sidebar_collapsed_change', handler);
      } catch {
        // ignore
      }
    };
  }, []);

  const handleToggleSidebar = () => {
    setSidebarCollapsed((prev) => {
      const next = !prev;
      try {
        window.localStorage.setItem('openplay_sidebar_collapsed', next ? '1' : '0');
      } catch {
        // ignore
      }
      return next;
    });
  };

  return (
    <div className="min-h-screen bg-background">
      <div className={sidebarCollapsed ? 'md:pl-[72px]' : 'md:pl-[240px]'}>
        {children}
      </div>
      <BottomTabNavigation
        userRole={userRole}
        sidebarCollapsed={sidebarCollapsed}
        onToggleSidebar={handleToggleSidebar}
      />
    </div>
  );
};

export default OpenPlayToolsLayout;
